var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "font-size-16 font-size-md-24 font-weight-regular font-pretendard",
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto",
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-10px pl-md-0 pr-md-20px py-md-24px py-lg-40px w-md-160px"
  }, [_c('div', {
    staticClass: "font-weight-extrabold grey--text text--darken-4"
  }, [_vm._t("title")], 2)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-4px pb-10px px-md-20px py-md-24px py-lg-40px"
  }, [_c('div', {
    staticClass: "font-size-18 font-size-md-24"
  }, [_vm._t("text")], 2)])])], 1), _c('v-divider')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }